import Vue from 'vue'
import { Container, Draggable } from 'vue-smooth-dnd'

Vue.component('smooth-dnd-container', Container)
Vue.component('smooth-dnd-draggable', Draggable)